import { __decorate, __metadata } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let TimerMinute = /** @class */ (() => {
    let TimerMinute = class TimerMinute extends Vue {
        constructor() {
            super(...arguments);
            this.minutes = 0;
            this.hours = 0;
        }
        created() {
            this.hours = Math.floor(this.totalSeconds / 3600) ?? 0;
            this.minutes = Math.floor((this.totalSeconds % 3600) / 60) ?? 0;
            this.intervalId = setInterval(() => {
                this.incrementMinutesAndHours();
            }, 60 * 1000);
        }
        destroyed() {
            clearInterval(this.intervalId);
        }
        incrementMinutesAndHours() {
            this.minutes++;
            if (this.minutes >= 60) {
                this.minutes = 0;
                this.hours++;
            }
            this.emitSeconds();
        }
        emitSeconds() {
            const totalSeconds = this.hours * 3600 + this.minutes * 60;
            this.$emit("seconds", totalSeconds);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], TimerMinute.prototype, "totalSeconds", void 0);
    TimerMinute = __decorate([
        Component
    ], TimerMinute);
    return TimerMinute;
})();
export default TimerMinute;
